import React from "react";
import { PolicyLayout, H2 } from "./PolicyLayout";

const RefundPolicy = () => (
  <PolicyLayout
    title="Refund & Cancellation Policy – Revibe Health and Happiness"
    updated="22 July 2026"
  >
    <H2>1. Webinar Registration</H2>
    <p>
      Registration for our Daily Live Webinar is free. If you miss your
      registered session, our team will contact you via WhatsApp on
      +91-9967756867 with the next available date. No cancellation needed.
    </p>

    <H2>2. Paid Diet Program</H2>
    <p>
      a) Refund Window: Full refund available within 7 days of payment if
      program access is under 20%.
    </p>
    <p>
      b) Request Process: Email billing@swapnilgautam.com with registered
      mobile number +91-9967756867.
    </p>
    <p>c) Processing: 5-7 business days to original payment method.</p>

    <H2>3. No Refund</H2>
    <p>
      No Refund After 7 days or after coaching sessions/materials are
      delivered.
    </p>

    <H2>4. Company Initiated Cancellation</H2>
    <p>If Revibe cancels a program, full refund will be issued.</p>

    <H2>5. Contact</H2>
    <p>
      REVIBE HEALTH AND HAPPINESS
      <br />
      GSTIN: 27ABLFR6155M1ZH
      <br />
      2206, 22nd Floor, Solus, Hiranandani Estate, Thane 400607
      <br />
      billing@swapnilgautam.com | +91-9967756867
    </p>
  </PolicyLayout>
);

export default RefundPolicy;
